/* custom-image-banner-button.js
   Nút "Scroll" của section Custom Banner Button: cuộn mượt xuống section
   THỨ N của template (đọc từ data-ibb-target, đếm từ trên xuống dưới).
   Dùng event delegation trên document → hoạt động cả khi Theme Editor
   load/unload/di chuyển section (không cần re-init). */
(function () {
  'use strict';

  function scrollToTargetSection(btn) {
    var current = btn.closest('.shopify-section');
    if (!current || !current.parentElement) return;
    // Các section cùng cấp = các section của template, theo thứ tự từ trên xuống
    var sections = Array.prototype.filter.call(current.parentElement.children, function (el) {
      return el.classList && el.classList.contains('shopify-section');
    });
    var idx = parseInt(btn.getAttribute('data-ibb-target'), 10);
    if (isNaN(idx) || idx < 1) idx = 1;
    var target = sections[idx - 1];
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ibb-scroll]');
    if (!btn) return;
    e.preventDefault();
    scrollToTargetSection(btn);
  });
})();
